window.updateProuductsInventory = () => {
    all_playlists.forEach(playlist => {
        fetch(`/apps/proxy/collections/check-inventory/${playlist.collection_id}`)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    const newProducts = playlist.playlist_products.map(product => {
                        const stockProduct = data.data.products.find(p => p.shopifyProductId == product.id);

                        if (!stockProduct) return product; // skip if no stock data

                        const mergedVariants = product.variants.map(variant => {
                            const stock = stockProduct.variants.find(s => s.shopifyVariantId == variant.id);
                            return {
                                ...variant,
                                ...(stock ? {
                                    available: stock.availableQuantity > 0 ? true : false,
                                    totalQuantity: stock.totalQuantity,
                                    consumedQuantity: stock.consumedQuantity,
                                    availableQuantity: stock.availableQuantity
                                    } : {
                                    })
                            };
                        });

                        return {
                            ...product,
                            variants: mergedVariants // ✅ update product variants
                        };
                    });
                    playlist.playlist_products = newProducts;
                }
            })
            .catch(err => console.error("Error fetching inventory:", err));
    });
    window.playlistLoaded = true;
};

window.all_playlists = null;
window.playlistLoaded = false;

window.fetchPlaylistData = async () => {
  try {
    const expiryKey = 'playlistdata_expiry';
    const playlistKey = 'playlistdata';

    // Check if expiration session exists and if it is still valid
    const expiryTimeStr = sessionStorage.getItem(expiryKey);
    const cachedData = sessionStorage.getItem(playlistKey);
    const now = Date.now();
    let dataFromSession = false;

    if (cachedData && expiryTimeStr) {
      const expiryTime = parseInt(expiryTimeStr, 10);
      if (!isNaN(expiryTime) && now < expiryTime) {
        // Use cached data, not expired
        console.log('Loading playlist data from session storage');
        window.all_playlists = JSON.parse(cachedData);
        window.all_bundle_products = [];
        window.all_playlists.forEach(playlist => {
          window.all_bundle_products.push(playlist.bundle_product);
        });
        dataFromSession = true;
        window.playlistLoaded = true;
        return;
      } else {
        // Expired: update the expiry for next time
        console.log('Playlist data cache expired, fetching fresh data...');
      }
    }

    // Either data doesn't exist, or cache expired
    // Fetch fresh data from server
    console.log('Fetching fresh playlist data from server');
    const response = await fetch('/collections/all?section_id=playlistdata');
    const data = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, 'text/html');
    const json = doc.querySelector('#playlist-data').textContent;

    // Store new expiry time: 2 minutes (120000ms) from now
    const newExpiryTime = Date.now() + 2 * 60 * 1000;
    sessionStorage.setItem(expiryKey, String(newExpiryTime));

    if(window.customAppConfigurationSettings.enableVirtualInventoryCheck){
      window.all_playlists = JSON.parse(json);
      window.updateProuductsInventory();
    }
    else{
        window.all_playlists = JSON.parse(json);
        window.playlistLoaded = true;
    }

    sessionStorage.setItem(playlistKey, JSON.stringify(window.all_playlists));

    window.all_bundle_products = [];
    window.all_playlists.forEach(playlist => {
      window.all_bundle_products.push(playlist.bundle_product);
    });

  } catch(error) {
    console.error("Error fetching playlist data:", error);
    window.playlistLoaded;
  }
}

window.fetchPlaylistData();
// fetch('/collections/all?section_id=playlistdata')
//     .then(response => response.text())
//     .then(data => {
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(data, 'text/html');
//         const json = doc.querySelector('#playlist-data').textContent;
//         window.all_playlists = JSON.parse(json);
//         window.updateProuductsInventory();
//         window.all_bundle_products = [];
//         window.all_playlists.forEach(playlist => {
//             window.all_bundle_products.push(playlist.bundle_product);
//         });
//     });

window.volume_discount_data = {
    "1": 0,
    "2": 5,
    "3": 10,
    "4": 15,
    "5": 18
};
window.isWithinSevenDays = function(dateString, days = 7) {
    if (typeof dateString !== "string") {
        throw new Error("dateString must be a string");
    }
    const inputDate = new Date(dateString);
    if (isNaN(inputDate.getTime())) {
        throw new Error("Invalid date string provided");
    }
    const today = new Date();

    // Reset time portion to compare only dates
    today.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);

    // Calculate difference in milliseconds
    const diffInMs = Math.abs(inputDate - today);

    // Convert milliseconds to days
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    // Return true if difference is less than specified days, false otherwise
    return diffInDays < days;
}
window.getDiscountPrice = (price, count) => {
    return price * (1 - window.volume_discount_data[count] / 100);
};
window.removeDuplicates = (arr, key) => {
  const seen = new Set();
  return arr.filter(item => {
    const val = item[key];
    if (seen.has(val)) return false;
    seen.add(val);
    return true;
  });
}
window.playlistUtilities = {
    getPlaylistData(playlistHandle) {
        return window.all_playlists.find(playlist => playlist.playlist_handle == playlistHandle);
    },
    getPlaylistDataByBundleProductId(bundleProductId) {
        return window.all_playlists.find(playlist => playlist.bundle_product.id == bundleProductId);
    },
    getPlaylistDataByBundleVariantId(bundleVariantId) {
        return window.all_playlists.find(playlist => playlist.bundle_product.variants.some(variant => variant.id == bundleVariantId));
    },
    getPlaylistDataByProductID(productID) {
        return window.all_playlists.find(playlist => {
            if (playlist.playlist_handle === "mixtape") {
                return false; // skip and continue
            }
            return playlist.playlist_products.some(product => product.id == productID);
        });
    },
    getProductObjectById(productID) {
        let productObject = null;
        window.all_playlists.forEach(playlist => {
            if (playlist.playlist_products.some(product => product.id == productID)) {
                productObject = playlist.playlist_products.find(product => product.id == productID);
                return true;
            }
        });
        return productObject;
    },
    getProductObjectByVariantId(variantId) {
        let productObject = null;
        window.all_playlists.forEach(playlist => {
            if (playlist.playlist_products.some(product => product.variants.some(variant => variant.id == variantId))) {
                productObject = playlist.playlist_products.find(product => product.variants.some(variant => variant.id == variantId));
                return true;
            }
        });
        return productObject;
    },
    getVariantObjectByVariantId(variantId) {
        const variantObject = window.all_playlists.find(playlist => playlist.playlist_products.some(product => product.variants.some(variant => variant.id == variantId)))?.playlist_products.find(product => product.variants.some(variant => variant.id == variantId));
        if(variantObject && variantObject.variants.some(variant => variant.id == variantId)){
            return variantObject.variants.find(variant => variant.id == variantId);
        }
        return null;
    },
    getDynamicBundleDefaultSelection: (playlistHandle, brewData = { filter: 1, espresso: 1 }, sellingPlanName = "3 week") => {
        const playlistData = playlistUtilities.getPlaylistData(playlistHandle);
        
        const playlistProducts = playlistData.playlist_products;
        let bundleSelections = [];
        let selectionProductListing = [];
        let totalProductPrice = 0;
        let bundleObject = {
            externalVariantId: playlistData.bundle_product.variants[0].id,
            externalProductId: playlistData.bundle_product.id,
            quantity: 1,
            selections: []
        }

        Object.keys(brewData).forEach(key => {
            playlistProducts.filter(product => {
                if (product.tags.includes(`${key}`) && brewData[key] > 0) {
                    const sellingPlanGroupId = product.selling_plan_groups.find(group =>
                        group.name.toLowerCase().includes(sellingPlanName.toLowerCase())
                    );

                    if (sellingPlanGroupId) {
                        return product.variants.some(variant => {
                            const sellingPlanAllocation = variant.selling_plan_allocations.find(
                                allocation => allocation.selling_plan_group_id === sellingPlanGroupId.id
                            );

                            if (sellingPlanAllocation && variant.available) {
                                if (
                                    variant.title === "300g" ||
                                    variant.title === "300G" ||
                                    variant.title === "300 G" ||
                                    variant.title === "300 g"
                                ) {
                                    bundleSelections.push({
                                        collectionId: playlistData.collection_id,
                                        externalProductId: String(product.id),
                                        externalVariantId: String(variant.id),
                                        quantity: 1,
                                        sellingPlan: sellingPlanAllocation.selling_plan_id
                                    });
                                    totalProductPrice += variant.price;
                                    selectionProductListing.push(product);
                                    brewData[key] = brewData[key] - 1;
                                    return true; // stops `some`
                                }
                            }
                            return false;
                        });
                    }
                }
                return false;
            });

        });
        bundleObject.selections = bundleSelections;
        return { bundleSelections, bundleObject,playlistData, totalProductPrice ,selectionProductListing };
    },
    getDynamicBundleSelection: (
        playlistHandle,
        productsCount = 3,
        brewData = { filter: 1, espresso: 1 },
        sellingPlanName = "3 week",
        excludeDecafe = false
    ) => {
      console.log("dynamic bundle selection running")
      console.log(excludeDecafe,"excludeDecafe");
        const playlistData = playlistUtilities.getPlaylistData(playlistHandle);
        let playlistProducts = playlistData.playlist_products;
        if(excludeDecafe){
          playlistProducts = playlistProducts.filter(p => !p.tags.includes("decaf"));
        }
        const bundleProduct = playlistData.bundle_product;
        const externalCollectionId = playlistData.collection_id;

         // --- Selections ---
         let bundleSelections = [];
         let selectionProductListing = [];
         let totalProductPrice = 0;
         let totalProductCount = 0;
      
         // Loop through brewData keys (filter, espresso, etc.)
        Object.keys(brewData).forEach(key => {
            let neededCount = brewData[key]; // how many products to add for this tag
            if (neededCount <= 0) return;
          
            // Filter products that match this tag
            const matchingProducts = playlistProducts.filter(p => p.tags.includes(key));
        
            for (let product of matchingProducts) {
                if (neededCount <= 0) break; // stop if quota filled
              
                // find a valid variant (any "300g" variant with stock)
                const validVariant = product.variants.find(v =>
                    ["300g", "300G", "300 G", "300 g"].includes(v.title) &&
                    v.available
                );
                
                let sellingPlanAllocation = null;
                
                // Improved selling plan lookup: match group either by .name as before or by having a selling_plan whose name matches sellingPlanName (case-insensitive)
                if (product.selling_plan_groups) {
                    sellingPlanAllocation = product.selling_plan_groups.find(group => {
                        // If group.name matches sellingPlanName
                        if (group.name && group.name.toLowerCase().includes(sellingPlanName.toLowerCase())) return true;
                        // Or, if any selling_plan in group matches the sellingPlanName
                        if (Array.isArray(group.selling_plans)) {
                            return group.selling_plans.some(plan =>
                                plan.name && plan.name.toLowerCase().includes(sellingPlanName.toLowerCase())
                            );
                        }
                        return false;
                    });
                }
                 
                // Check if validVariant exists and has a selling plan that contains the sellingPlanName parameter
                if (
                    validVariant &&
                    sellingPlanAllocation
                ) {
                    bundleSelections.push({
                        collectionId: playlistData.collection_id,
                        externalProductId: String(product.id),
                        externalVariantId: String(validVariant.id),
                        quantity: 1,
                        sellingPlan: sellingPlanAllocation.selling_plans.find(plan =>
                            plan.name.toLowerCase().includes(sellingPlanName.toLowerCase())
                        ).id
                    });
                    selectionProductListing.push(product);
                    totalProductPrice += validVariant.price;
                    neededCount--; // reduce required count
                    totalProductCount++;
                }
            }
        });
        // Final bundle object
        let bundleObject = {
            externalVariantId: bundleProduct.variants[0].id,
            externalProductId: playlistData.bundle_product.id,
            quantity: 1,
            selections: bundleSelections
          };
        let discountedPrice = getDiscountPrice(totalProductPrice, totalProductCount);
        return { bundleSelections, bundleObject,bundleProduct, playlistData, totalProductPrice, selectionProductListing, discountedPrice, totalProductCount, externalCollectionId };
    },
    // getStaticBundleSelection: (
    //     playlistHandle,
    //     productsCount = 3,
    //     brewData = { filter: 1, espresso: 1 },
    //     sellingPlanName = "3 week"
    //   ) => {
    //     const playlistData = playlistUtilities.getPlaylistData(playlistHandle);
    //     const playlistProducts = playlistData.playlist_products;
    //     const bundleProduct = playlistData.bundle_product;
    //     const externalCollectionId = playlistData.collection_id;
    //     let singleVariantPrice = 0;
    //     console.log(playlistHandle,"playlistHandle");
    //     // --- Find correct variant for productsCount ---
    //     const matchVariant = bundleProduct.variants.find(v =>
    //       v.title.includes(productsCount.toString())
    //     );
    //     console.log(bundleProduct,"bundleProduct.variants");
    //     console.log(productsCount,"productsCount");
    //     console.log(matchVariant,"matchVariant");
    //     const quantityVariant = matchVariant ? matchVariant.id : bundleProduct.variants[0].id;
      
    //     // --- Find correct selling plan ---
    //     let sellingPlan = null;
    //     if(bundleProduct.selling_plan_groups.length > 0){
    //     const matchPlanGroup = bundleProduct.selling_plan_groups.find(group =>
    //       group.name.toLowerCase().includes(sellingPlanName.toLowerCase())
    //     );
    //      sellingPlan = matchPlanGroup
    //       ? matchPlanGroup.selling_plans[0].id
    //       : bundleProduct.selling_plan_groups[0].selling_plans[0].id;
    //     } 
    //     // --- Selections ---
    //     let bundleSelections = [];
    //     let selectionProductListing = [];
    //     let totalProductPrice = matchVariant.compare_at_price || 0;
    //     let totalProductCount = 0;
    //     console.log(quantityVariant,"quantityVariant");
    //     // Loop through brewData keys (filter, espresso, etc.)
    //     Object.keys(brewData).forEach(key => {
    //       let neededCount = brewData[key]; // how many products to add for this tag
    //       if (neededCount <= 0) return;
      
    //       // Filter products that match this tag
    //       const matchingProducts = playlistProducts.filter(p => p.tags.includes(key));
      
    //       for (let product of matchingProducts) {
    //         if (neededCount <= 0) break; // stop if quota filled
      
    //         // find a valid variant (any "300g" variant with stock)
    //         const validVariant = product.variants.find(v =>
    //           ["300g", "300G", "300 G", "300 g"].includes(v.title) &&
    //           v.available
    //         );
      
    //         if (validVariant) {
    //           bundleSelections.push({
    //             collectionId: playlistData.collection_id,
    //             externalProductId: String(product.id),
    //             externalVariantId: String(validVariant.id),
    //             quantity: 1
    //           });
      
    //           selectionProductListing.push(product);
    //           // totalProductPrice += validVariant.price;
    //           neededCount--; // reduce required count
    //           totalProductCount++;
    //         }
    //       }
    //     });
      
    //     // Final bundle object
    //     let bundleObject = {
    //       externalVariantId: quantityVariant,
    //       externalProductId: playlistData.bundle_product.id,
    //       quantity: 1,
    //       selections: bundleSelections
    //     };
    //     let discountedPrice = 0;
    //     if(playlistHandle == "mixtape"){
    //         switch(productsCount){
    //             case 2:
    //                 discountedPrice = 3823;
    //                 break;
    //             case 3:
    //                 discountedPrice = 5734;
    //                 break;
    //             case 4:
    //                 discountedPrice = 7645;
    //                 break;
    //             case 5:
    //                 discountedPrice = 9556;
    //                 break;
    //         }
    //     }
    //     else{
    //          discountedPrice = bundleProduct.variants.find(v => v.title.includes(productsCount.toString()))?.price || 0;
    //     }

    //     return { bundleSelections, bundleObject, bundleProduct,playlistData, totalProductPrice, selectionProductListing, sellingPlan, discountedPrice ,externalCollectionId };
    // },
    getStaticBundleSelection:(
      playlistHandle,
      productsCount = 2,
      brewData = { filter: 1, espresso: 1 },
      sellingPlanName = "3 week" 
    ) => {
      const playlistData = playlistUtilities.getPlaylistData(playlistHandle);
      const playlistProducts = playlistData.playlist_products;
      const bundleProduct = playlistData.bundle_product;
      const externalCollectionId = playlistData.collection_id;
      let singleVariantPrice = 0;
      console.log(playlistHandle, "playlistHandle");
      
      // --- Find correct variant for productsCount ---
      const matchVariant = bundleProduct.variants.find(v =>
        v.title.includes(productsCount.toString())
      );
      console.log(bundleProduct, "bundleProduct.variants");
      console.log(productsCount, "productsCount");
      console.log(matchVariant, "matchVariant");
      const quantityVariant = matchVariant ? matchVariant.id : bundleProduct.variants[0].id;
    
      // --- Find correct selling plan ---
      let sellingPlan = null;
        if (bundleProduct.selling_plan_groups.length > 0) {
          console.log(bundleProduct.selling_plan_groups, "bundleProduct.selling_plan_groups");
          bundleProduct.selling_plan_groups[0].selling_plans.forEach(group => {
            if(group.name.toLowerCase().includes(sellingPlanName.toLowerCase())){
              sellingPlan = group.id;
            }
          })
        }
          console.log("seeling plan first statergey",sellingPlan)
        if(sellingPlan == null){
          if (bundleProduct.selling_plan_groups.length > 0) {
          bundleProduct.selling_plan_groups.forEach(group => {
            group.selling_plans.forEach(plan => {
              if(plan.name.toLowerCase().includes(sellingPlanName.toLowerCase())){
                sellingPlan = plan.id;
              }
            })
          });
        }
       }
      
      console.log(sellingPlan, "sellingPlan");
      
      // --- First, collect all available products and separate by tag ---
      const availableProductsByTag = {};
      
      // Get all unique tags from brewData
      Object.keys(brewData).forEach(tag => {
        if (brewData[tag] <= 0) return;
        
        // Filter products that match this tag
        const matchingProducts = playlistProducts.filter(p => p.tags.includes(tag));
        
        // Find valid variants for each product
        const availableProducts = matchingProducts
          .map(product => {
            const validVariant = product.variants.find(v =>
              ["300g", "300G", "300 G", "300 g"].includes(v.title) &&
              v.available
            );
            return validVariant ? { product, variant: validVariant } : null;
          })
          .filter(item => item !== null);
        
        availableProductsByTag[tag] = availableProducts;
      });
      
      console.log("Available products by tag:", availableProductsByTag);
      
      // --- Now distribute quantities for each tag ---
      let bundleSelectionsMap = new Map(); // Use Map to track unique variants
      let selectionProductListing = [];
      let totalProductCount = 0;
      
      Object.keys(brewData).forEach(tag => {
        const neededCount = brewData[tag];
        if (neededCount <= 0) return;
        
        const availableProducts = availableProductsByTag[tag] || [];
        
        if (availableProducts.length === 0) {
          console.warn(`No available products found for tag: ${tag}`);
          return;
        }
        
        // Calculate distribution
        const productsToUse = availableProducts.length;
        const baseQuantity = Math.floor(neededCount / productsToUse);
        const remainder = neededCount % productsToUse;
        
        console.log(`Tag: ${tag}, Needed: ${neededCount}, Available: ${productsToUse}, Base: ${baseQuantity}, Remainder: ${remainder}`);
        
        // Distribute products with quantities
        availableProducts.forEach((item, index) => {
          // First 'remainder' products get an extra unit
          const quantity = baseQuantity + (index < remainder ? 1 : 0);
          
          if (quantity > 0) {
            const variantKey = String(item.variant.id);
            
            // Check if this variant already exists in the map
            if (bundleSelectionsMap.has(variantKey)) {
              // Add to existing quantity
              const existing = bundleSelectionsMap.get(variantKey);
              existing.quantity += quantity;
            } else {
              // Add new entry
              bundleSelectionsMap.set(variantKey, {
                collectionId: playlistData.collection_id,
                externalProductId: String(item.product.id),
                externalVariantId: String(item.variant.id),
                quantity: quantity
              });
              selectionProductListing.push(item.product);
            }
            
            totalProductCount += quantity;
          }
        });
      });
      
      // Convert Map to Array
      const bundleSelections = Array.from(bundleSelectionsMap.values());

      // Create a new array, splitting any entry with quantity > 2 into multiple entries of 1 each
      const flatBundleSelections = [];
      bundleSelections.forEach(item => {
        if (item.quantity > 1) {
          for (let i = 0; i < item.quantity; i++) {
            flatBundleSelections.push({
              ...item,
              quantity: 1
            });
          }
        } else {
          flatBundleSelections.push(item);
        }
      });
      
      console.log("Final bundle selections:", flatBundleSelections);
      console.log("Total product count:", totalProductCount);
    
      // --- Calculate total price ---
      let totalProductPrice = matchVariant.compare_at_price || 0;
      console.log(quantityVariant, "quantityVariant");
    
      // Final bundle object
      let bundleObject = {
        externalVariantId: quantityVariant,
        externalProductId: playlistData.bundle_product.id,
        quantity: 1,
        selections: flatBundleSelections
      };
      
      let discountedPrice = 0;
      if (playlistHandle == "mixtape") {
        switch (productsCount) {
          case 2:
            discountedPrice = 3823;
            break;
          case 3:
            discountedPrice = 5734;
            break;
          case 4:
            discountedPrice = 7645;
            break;
          case 5:
            discountedPrice = 9556;
            break;
        }
      } else {
        discountedPrice = bundleProduct.variants.find(v => v.title.includes(productsCount.toString()))?.price || 0;
      }
    
      return { 
        bundleSelections, 
        bundleObject, 
        bundleProduct, 
        playlistData, 
        totalProductPrice, 
        selectionProductListing, 
        sellingPlan, 
        discountedPrice, 
        externalCollectionId 
      };
    },
    convertBundleObjectToRechargeBundleObject(bundleObject) {
        return {
            external_product_id: { ecommerce: String(bundleObject.externalProductId) },
            external_variant_id: { ecommerce: String(bundleObject.externalVariantId) },
            quantity: bundleObject.quantity,
            items: bundleObject.selections.map(selection => ({
                collection_id: selection.collectionId,
                collection_source: 'shopify',
                external_product_id: selection.externalProductId,
                external_variant_id: selection.externalVariantId,
                quantity: selection.quantity
            }))
        };
    },
    getPlaylistDataByProductID(productID) {
        const playlist = window.all_playlists.find(playlist => {
            // skip mixtape
            if (playlist.playlist_handle === "mixtape") {
                return false; // skip and continue
            }

            // match if product exists in this playlist
            return playlist.playlist_products.some(product => product.id == productID);
        });

        return playlist || null; // return playlist if found, else null
    },
    getStaticBundlePrice(playlistHandle, productsCount) {
        const playlistData = playlistUtilities.getPlaylistData(playlistHandle);
        const bundleProduct = playlistData.bundle_product;
        const matchVariant = bundleProduct.variants.find(v => v.title.includes(productsCount.toString()));
        return matchVariant ? matchVariant.price : 0;
    },
    getDynamicMultiPlaylistBundleSelection (
      playlistHandle,
      productsCount = 3,
      brewData = { filter: 1, espresso: 1 },
      sellingPlanName = "3 week",
      excludeDecafe = false
    ) {
      console.log("getDynamciMulti")
      // Validate productsCount matches available playlists
      if (productsCount > all_playlists.length && productsCount !== 5 && productsCount !== 2) {
        console.error(`Requested ${productsCount} products but only ${all_playlists.length} playlists available`);
        return null;
      }
      const collectionId = playlistUtilities.getPlaylistData(playlistHandle).collection_id;
      const playlistData = playlistUtilities.getPlaylistData(playlistHandle);
      
      // --- Selections ---
      let bundleSelections = [];
      let selectionProductListing = [];
      let totalProductPrice = 0;
      let totalProductCount = 0;
      let bundleProduct = playlistData.bundle_product;
    
      // Create a queue of tags based on brewData
      let tagQueue = [];
      
      // Normal distribution
      Object.keys(brewData).forEach(key => {
        for (let i = 0; i < brewData[key]; i++) {
          tagQueue.push(key);
        }
      });
    
      // Validate tagQueue length matches productsCount
      if (tagQueue.length !== productsCount) {
        console.error(`brewData counts (${tagQueue.length}) don't match productsCount (${productsCount})`);
        return null;
      }
    
      // Loop through each playlist up to productsCount
      for (let i = 0; i < productsCount; i++) {
        let playlistIndex = i;
        
        // Special case for productsCount = 2:
        // Position 0: playlist[1]
        // Position 1: playlist[2]
        if (productsCount === 2) {
          playlistIndex = i + 1;  // Skip playlist[0], use playlist[1] and playlist[2]
        }
        
        // Special case for productsCount = 5:
        // Position 0: playlist[0]
        // Position 1: playlist[1]
        // Position 2: playlist[2]
        // Position 3: playlist[2] (2nd product from playlist[2])
        // Position 4: playlist[3]
        if (productsCount === 5) {
          if (i === 3) {
            playlistIndex = 2;  // Position 3 comes from playlist[2]
          } else if (i === 4) {
            playlistIndex = 3;  // Position 4 comes from playlist[3]
          }
          // else: positions 0, 1, 2 use their normal index (i)
        }
        
        const currentPlaylistData = all_playlists[playlistIndex];
        let playlistProducts = [];
        if(excludeDecafe){
          playlistProducts = currentPlaylistData.playlist_products.filter(p => !p.tags.includes("decaf"));
        }
        else{
          playlistProducts = currentPlaylistData.playlist_products;
        }

        // Get the tag we need for this playlist
        const requiredTag = tagQueue[i];
    
        // Filter products that match the required tag
        const matchingProducts = playlistProducts.filter(p => 
          p.tags.includes(requiredTag)
        );
    
        // Find a valid product from matching products
        let productFound = false;
        for (let product of matchingProducts) {
          // Skip if this product is already selected (avoid duplicates)
          if (selectionProductListing.some(p => p.id === product.id)) {
            continue;
          }
          
          // Find a valid variant (any "300g" variant with stock)
          const validVariant = product.variants.find(v =>
            ["300g", "300G", "300 G", "300 g","300"].includes(v.title) &&
            v.available
          );
    
          let sellingPlanAllocation = null;
          if (product.selling_plan_groups) {
            sellingPlanAllocation = product.selling_plan_groups.find(group => {
                // If group.name matches sellingPlanName
                if (group.name && group.name.toLowerCase().includes(sellingPlanName.toLowerCase())) return true;
                // Or, if any selling_plan in group matches the sellingPlanName
                if (Array.isArray(group.selling_plans)) {
                    return group.selling_plans.some(plan =>
                        plan.name && plan.name.toLowerCase().includes(sellingPlanName.toLowerCase())
                    );
                }
                return false;
            });
          }
    
          // Check if validVariant exists and has a selling plan
          if (validVariant && sellingPlanAllocation) {
            console.log(`Found product for ${requiredTag} in playlist[${playlistIndex}] at position ${i}`);
            
            bundleSelections.push({
              collectionId: collectionId,
              externalProductId: String(product.id),
              externalVariantId: String(validVariant.id),
              quantity: 1,
              sellingPlan: sellingPlanAllocation.selling_plans.find(plan =>
                plan.name.toLowerCase().includes(sellingPlanName.toLowerCase())
              ).id
            });
    
            selectionProductListing.push(product);
            totalProductPrice += validVariant.price;
            totalProductCount++;
            productFound = true;
            break; // Stop after finding one valid product for this playlist
          }
        }
    
        if (!productFound) {
          console.warn(`No valid product found for tag "${requiredTag}" in playlist[${playlistIndex}] at position ${i}`);
          throw new Error("no product found")
        }
      }
    
      // Check if we found all required products
      // if (totalProductCount !== productsCount) {
      //   console.error(`Only found ${totalProductCount} products out of ${productsCount} required`);
      //   return null;
      // }
    
      // Final bundle object
      let bundleObject = {
        externalVariantId: bundleProduct.variants[0].id,
        externalProductId: bundleProduct.id,
        quantity: 1,
        selections: bundleSelections
      };
    
      let discountedPrice = getDiscountPrice(totalProductPrice, totalProductCount);
    
      return {
        bundleSelections,
        bundleObject,
        bundleProduct,
        playlistData,
        totalProductPrice,
        selectionProductListing,
        discountedPrice,
        totalProductCount,
        externalCollectionId:collectionId
      };
    },
    curatedStaticSelection: (
      playlistHandle,
      productsCount = 3,
      sellingPlanName = "3 week"
    ) => {
      const playlistData = playlistUtilities.getPlaylistData(playlistHandle);
      const playlistProducts = playlistData.playlist_products;
      const bundleProduct = playlistData.bundle_product;
    
      // --- Find correct variant for productsCount ---
      const matchVariant = bundleProduct.variants.find(v =>
        v.title.includes(productsCount.toString())
      );
      const quantityVariant = matchVariant ? matchVariant.id : bundleProduct.variants[0].id;
    
      // --- Find correct selling plan ---
      let sellingPlan = null;
      if(bundleProduct.selling_plan_groups.length > 0){
        const matchPlanGroup = bundleProduct.selling_plan_groups.find(group =>
          group.name.toLowerCase().includes(sellingPlanName.toLowerCase())
        );
        sellingPlan = matchPlanGroup
          ? matchPlanGroup.selling_plans[0].id
          : bundleProduct.selling_plan_groups[0].selling_plans[0].id;
      }
    
      // --- Selections ---
      let bundleSelections = [];
      let selectionProductListing = [];
      let totalProductPrice = 0;
      let totalProductCount = 0;
    
      // Select first N products with valid 300g variants (no brewData filtering)
      for (let product of playlistProducts) {
        if (totalProductCount >= productsCount) break; // stop when we have enough products

        const validVariant = product.variants[0]
    
        if (validVariant) {
          bundleSelections.push({
            collectionId: playlistData.collection_id,
            externalProductId: String(product.id),
            externalVariantId: String(validVariant.id),
            quantity: 1
          });
    
          selectionProductListing.push(product);
          totalProductPrice += validVariant.price;
          totalProductCount++;
        }
      }
    
      // Final bundle object
      let bundleObject = {
        externalVariantId: quantityVariant,
        externalProductId: playlistData.bundle_product.id,
        quantity: 1,
        selections: bundleSelections
      };
    
      let discountedPrice = 0;
      discountedPrice = bundleProduct.variants.find(v => v.title.includes(productsCount.toString()))?.price || 0;
    
      return { 
        bundleSelections, 
        bundleObject, 
        bundleProduct,
        playlistData, 
        totalProductPrice, 
        selectionProductListing, 
        sellingPlan, 
        discountedPrice 
      };
    }
      
}
window.subscriptionHelper = {
    getBrewTag(subscriptionData, brew) {
      const subscriptionProperties = subscriptionData?.properties || [];
  
      // Build the property name dynamically
      const propertyName = `grind_${brew}`;
  
      // Find the property
      const match = subscriptionProperties.find(
        (prop) => prop.name === propertyName
      );
  
      return {
        subscriptionData,
        subscriptionProperties,
        brew,
        grind: match ? match.value : null
      };
    },
    getSkipChargeDates(subscription, numberOfSkips = 1) {
        const { order_interval_frequency, order_interval_unit, next_charge_scheduled_at } = subscription;
      
        if (!order_interval_frequency || !order_interval_unit || !next_charge_scheduled_at) {
          return [];
        }
      
        const results = [];
        let currentDate = new Date(next_charge_scheduled_at);
      
        for (let i = 0; i < numberOfSkips; i++) {
          let skippedDate = new Date(currentDate);
      
          switch (order_interval_unit) {
            case "day":
              skippedDate.setDate(skippedDate.getDate() + order_interval_frequency);
              break;
            case "week":
              skippedDate.setDate(skippedDate.getDate() + (order_interval_frequency * 7));
              break;
            case "month":
              skippedDate.setMonth(skippedDate.getMonth() + order_interval_frequency);
              break;
            default:
              throw new Error("Unsupported interval unit: " + order_interval_unit);
          }
      
          results.push(skippedDate.toISOString().split("T")[0]); // return YYYY-MM-DD format
          currentDate = skippedDate;
        }
      
        return results;
    },
    updateProperties(properties, updates) {
        // Clone the original so we don’t mutate it directly
        let updatedProps = [...properties];
      
        Object.entries(updates).forEach(([key, value]) => {
          // Find if the property already exists
          const existing = updatedProps.find(prop => prop.name === key);
      
          if (existing) {
            // Update value
            existing.value = value;
          } else {
            // Add new property
            updatedProps.push({ name: key, value });
          }
        });
      
        return updatedProps;
    },
    updateOrAddProperties(properties, updates) {
      // Clone the original array to avoid mutation
      const updatedProps = [...properties];
      
      Object.entries(updates).forEach(([key, value]) => {
        // Find the index of the existing property
        const existingIndex = updatedProps.findIndex(prop => prop.name === key);
        
        if (existingIndex !== -1) {
          // Property exists - update its value
          updatedProps[existingIndex] = {
            ...updatedProps[existingIndex],
            value
          };
        } else {
          // Property doesn't exist - add it
          updatedProps.push({ name: key, value });
        }
      });
      
      return updatedProps;
    },
    subscriptionPropertiesFormatted(input) {
        const output = [];
      
        for (const key in input) {
          if (!input.hasOwnProperty(key)) continue;
      
          let name = key;
          let value = input[key];
      
          // ensure everything is a string
          value = String(value);
      
          output.push({ name, value });
        }
      
        return output;
    },
    rubyHashToObject(str) {
        console.log(str,"str");
        if (typeof str !== "string") {
          throw new Error("Expected a string input");
        }
      
        let jsonLike = str.replace(/=>/g, ':');
        jsonLike = jsonLike.replace(/(\w+):/g, '"$1":');
        jsonLike = jsonLike.replace(/:"/g, ': "'); // space after colon for JSON
      
        return JSON.parse(jsonLike);
      }
};
window.allProducts = [];
window.getAllProducts = async () => {
  try {
    // Check if data exists in sessionStorage
    const cachedData = sessionStorage.getItem('allProduct');
    
    if (cachedData) {
      // Use cached data
      console.log('Loading all products from session storage');
      window.allProducts = JSON.parse(cachedData);
      return window.allProducts;
    }
    
    // If no cached data, fetch from server
    console.log('Fetching all products from server');
    const response = await fetch('/collections/all?section_id=all-products');
    const data = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, 'text/html');
    const json = doc.querySelector('#all-products').textContent;
    
    window.allProducts = JSON.parse(json) || [];
    
    // Store in sessionStorage for future page loads
    sessionStorage.setItem('allProduct', json);
    
    return window.allProducts;
    
  } catch(error) {
    console.error("Error fetching all products:", error);
    return [];
  }
}
window.getProductInventoryByProductId = async (productId) => {
  try {
    const response = await fetch(`/apps/proxy/products/check-inventory/${productId}`);
    const data = await response.json();
    if(data.success){
      return data.variants;
    }
    else{
      return null;
    }
  } catch(error) {
    console.error("Error fetching product inventory:", error);
    return null;
  }
}
// Auto-load on page load
window.getAllProducts();

window.getProductById = (id) => {
    return window.allProducts.find(product => product.id == id);
}

window.smoothScroll = function(element, target, duration = 800) {
    const start = element.scrollTop;
    const change = target - start;
    const startTime = performance.now();
  
    // Easing function (easeInOutCubic)
    const easeInOutCubic = t =>
      t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  
    function animateScroll(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1); // clamp 0–1
      const eased = easeInOutCubic(progress);
  
      element.scrollTop = start + change * eased;
  
      if (elapsed < duration) {
        requestAnimationFrame(animateScroll);
      }
    }
  
    requestAnimationFrame(animateScroll);
  }

  window.cartHelper = window.cartHelper || {};
  window.cartHelper.isBundleInCart = () =>{
    const mixtapeBundleInCart = window.cartObject.items.find(item => item.properties._rc_bundle_parent == "monogram-mixtape-subscription") ? true : false;
    if(mixtapeBundleInCart){
      return true;
    }
    else{
      const isBundleInCart = window.cartObject.items.some(item => {
        return window.all_bundle_products.find(product => product.id == item.product_id);
      });
      return isBundleInCart;
    }
  }
  window.cartHelper.isMoreThanOneBundleInCart = () =>{
    let bundleCount = 0;
    const mixtapeBundleInCart = window.cartObject.items.find(item => item.properties._rc_bundle_parent == "monogram-mixtape-subscription") ? true : false;
    if(mixtapeBundleInCart){
      bundleCount = bundleCount + 1;
    }
   
    const isBundleInCart = window.cartObject.items.some(item => {
      return window.all_bundle_products.find(product => product.id == item.product_id);
    });
    if(isBundleInCart){
      bundleCount = bundleCount + 1;
    }
    return bundleCount > 1 ? true : false;
  }

  window.subscriptionHelper.getFilterAndEspressoCountFromSubscription = function(subscription) {
    let filterCount = 0;
    let espressoCount = 0;
    if (!subscription || !subscription.include || !subscription.include.bundle_selections || !Array.isArray(subscription.include.bundle_selections.items)) {
      return { filter: filterCount, espresso: espressoCount };
    }

    const bundleSelections = subscription.include.bundle_selections.items;

    bundleSelections.forEach(selection => {
      // Get the product via external_product_id
      const externalProductId = selection.external_product_id;
      // Find the product in window.allProducts or window.all_bundle_products
      let product =
        (window.allProducts && window.allProducts.find(prod => String(prod.id) === String(externalProductId))) ||
        (window.all_bundle_products && window.all_bundle_products.find(prod => String(prod.id) === String(externalProductId)));

      if (!product) {
        // fallback if playlistUtilities global exists
        if (window.playlistUtilities && typeof window.playlistUtilities.getPlaylistDataByBundleProductId === 'function') {
          const playlistData = window.playlistUtilities.getPlaylistDataByBundleProductId(externalProductId);
          product = playlistData && playlistData.bundle_product ? playlistData.bundle_product : null;
        }
      }

      if (!product || !Array.isArray(product.tags)) return;

      const qty = typeof selection.quantity === 'number' && !isNaN(selection.quantity) ? selection.quantity : 1;

      // If product has "filter" tag
      if (product.tags.includes('filter')) {
        filterCount += qty;
      }
      // If product has "espresso" tag
      if (product.tags.includes('espresso')) {
        espressoCount += qty;
      }
    });

    return {
      filter: filterCount,
      espresso: espressoCount
    };
  }

window.changeSubscriptionPlaylistProductOrder = async function () {
  const repeatedData = window.repeatedCoffeedata || [];
  const repeatedIds = repeatedData.map((item) => String(item.productId));


  if (!repeatedIds.length) {
    console.warn('[chargePlaylistProductOrder] repeatedCoffeedata is empty, skipping.');
    return;
  }
  if (!Array.isArray(window.all_playlists)) {
    console.warn('[chargePlaylistProductOrder] window.all_playlists is not ready.');
    return;
  }

  window.all_playlists = window.all_playlists.map((playlist) => {
    if (!Array.isArray(playlist.playlist_products)) return playlist;

    const pinned = [];
    const rest = [];

    playlist.playlist_products.forEach((product) => {
      const pid = String(product.id);
      if (repeatedIds.includes(pid)) {
        pinned.push(product);
      } else {
        rest.push(product);
      }
    });

    pinned.sort((a, b) => {
      return repeatedIds.indexOf(String(a.id)) - repeatedIds.indexOf(String(b.id));
    });

    return { ...playlist, playlist_products: [...pinned, ...rest] };
  });
};